import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";

const values = [
  { icon: "ri-flashlight-line", title: "反应要快", desc: "新鲜事稍纵即逝，我们用实时榜单与即时更新，第一时间把焦点送到你面前。" },
  { icon: "ri-shield-check-line", title: "来源要真", desc: "对每条内容做信源核对与交叉验证，优先权威媒体与官方发布，不传未经证实的谣言。" },
  { icon: "ri-heart-3-line", title: "立场要正", desc: "保持客观中立的表达，不煽动对立、不恶意揣测，让吃瓜回归轻松与理性。" },
  { icon: "ri-group-line", title: "交流要和", desc: "尊重每一位读者的声音，鼓励友善讨论，一起营造温暖的吃瓜氛围。" },
];

const principles = [
  "以权威信源与官方发布为准，标注清晰、可溯源。",
  "未经核实的小道消息明确标注，绝不包装成既定事实。",
  "坚持真实、准确、客观，对明显的失实内容第一时间更正。",
  "保护当事人隐私，不传播臆测性内容，克制且负责。",
  "鼓励有温度的讨论，让信息在理性中流动。",
];

export default function About() {
  const aboutLd = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于在线吃瓜",
    url: "https://www.zgchigua.cn/about",
    inLanguage: "zh-CN",
  };

  return (
    <Layout>
      <Seo
        title="关于我们_品牌介绍与内容理念_在线吃瓜"
        description="了解在线吃瓜：一个追踪全网热门话题与新鲜事的实时资讯平台。查看我们的网站定位、发展理念与内容原则，我们坚持真实、及时、有温度，让吃瓜更清醒、更有条理。"
        keywords="关于在线吃瓜,在线吃瓜品牌介绍,在线吃瓜定位,内容原则,吃瓜文化"
        path="/about"
        jsonLd={[aboutLd]}
      />

      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-600 via-primary-500 to-secondary-500"></div>
        <div className="container-x relative py-12 text-background-50 md:py-16">
          <nav className="flex items-center gap-1 text-xs text-background-100/80" aria-label="面包屑">
            <Link to="/" className="hover:text-accent-300">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span>关于我们</span>
          </nav>
          <h1 className="mt-4 max-w-2xl font-heading text-3xl leading-tight md:text-5xl">把散落的热点，串成一份清醒的日常</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            在线吃瓜诞生于一个朴素的想法：在信息铺天盖地的今天，与其在无数个 App 之间来回切换，不如让每个人都能在一个地方，快速、准确地看到此刻全网都在聊什么。
          </p>
        </div>
      </section>

      <section className="container-x py-10 md:py-14">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="chip bg-primary-100 text-primary-800 px-3 py-1 text-xs font-bold"><i className="ri-rocket-line"></i> 网站定位</span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl">做你随手打开的热瓜雷达</h2>
            <p className="mt-3 leading-relaxed text-foreground-700">
              我们聚焦娱乐圈、影视综艺、社会热点、科技数码与生活潮流等领域的今日热瓜与新鲜事。通过聚合全网高热度话题、持续追踪事件进展，并定期输出经核实的背景解读，我们希望成为你了解当下舆论焦点、快速跟上朋友话题时的第一入口。
            </p>
            <p className="mt-3 leading-relaxed text-foreground-700">
              无论你是通勤路上的刷屏党、下班后的追剧人，还是需要捕捉潮流动向的内容从业者，都能在这里按自己关心的频道，找到真正想看的动态。
            </p>
            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {values.map((v) => (
                <div key={v.title} className="card-surface flex items-start gap-3 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700"><i className={`${v.icon} text-lg`}></i></span>
                  <div>
                    <h3 className="font-bold">{v.title}</h3>
                    <p className="mt-1 text-sm text-foreground-600">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-3xl">
              <img
                src="https://readdy.ai/api/search-image?query=friends%20casually%20looking%20at%20a%20smartphone%20and%20laughing%20around%20a%20table%20with%20warm%20coffee%20and%20magazines%2C%20bright%20cozy%20content%20team%20scene%2C%20warm%20natural%20light%2C%20editorial%20photography&width=820&height=900&seq=about-team-01&orientation=portrait"
                alt="在线吃瓜内容团队日常 - 一起追踪新鲜事"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100/70 py-10 md:py-14">
        <div className="container-x">
          <div className="mx-auto max-w-2xl text-center">
            <span className="chip bg-secondary-100 text-secondary-900 px-3 py-1 text-xs font-bold"><i className="ri-leaf-line"></i> 发展理念</span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl">热闹要有，清醒更要有</h2>
            <p className="mt-3 text-sm text-foreground-600">
              我们相信，围观和思考并不矛盾。真正高质量的吃瓜文化，是在保持好奇与热情的同时，也保留一份辨别真伪、理解脉络的从容。我们以媒体人的严谨要求自己，也希望把这种从容带给每一位读者。
            </p>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            {[
              { icon: "ri-live-line", n: "持续追踪", d: "不只报道一时热度，更跟进事件的完整脉络与后续进展，让新鲜事形成闭环。" },
              { icon: "ri-focus-3-line", n: "视角多元", d: "从事实、背景到公众情绪，多角度还原热点，帮助你更全面地理解一件事情。" },
              { icon: "ri-history-line", n: "长期主义", d: "不追逐一时的流量喧嚣，坚持以扎实的内容积累信任，与读者一同成长。" },
            ].map((c) => (
              <div key={c.n} className="card-surface p-6 text-center">
                <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-accent-100 text-accent-700"><i className={`${c.icon} text-2xl`}></i></span>
                <h3 className="mt-4 font-heading text-lg">{c.n}</h3>
                <p className="mt-2 text-sm text-foreground-600">{c.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-x py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div className="card-surface p-6 md:p-8">
            <span className="chip bg-primary-100 text-primary-800 px-3 py-1 text-xs font-bold"><i className="ri-shield-check-line"></i> 内容原则</span>
            <h2 className="mt-3 font-heading text-xl md:text-2xl">我们坚持这样生产内容</h2>
            <ul className="mt-5 space-y-3">
              {principles.map((p, i) => (
                <li key={i} className="flex items-start gap-3 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-line mt-0.5 text-primary-600"></i>
                  {p}
                </li>
              ))}
            </ul>
          </div>
          <div className="overflow-hidden rounded-3xl bg-gradient-to-br from-primary-100 to-secondary-100 p-6 md:p-8">
            <span className="chip bg-accent-500 px-3 py-1 text-xs font-bold text-background-50"><i className="ri-chat-quote-line"></i> 给读者的话</span>
            <blockquote className="mt-5 text-lg leading-relaxed text-foreground-800">
              “愿每一个打开在线吃瓜的你，都能在铺天盖地的信息里，既不缺席这场时代的围观，也始终保有属于自己的判断力。”
            </blockquote>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/ranking" className="chip bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 hover:bg-primary-600">去看看实时榜单</Link>
              <Link to="/contact" className="chip border border-primary-300 px-5 py-2.5 text-sm font-bold text-primary-700 hover:bg-background-50">联系我们</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}